/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/tabindex-no-positive */
import React, { useEffect, useRef, useState } from 'react'

import BaseCreatePage from '../../../components/hooks/BaseCreatePage'
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core'
import colors from '../../../assets/colors'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { resetPassword } from '../PasswordReset'

const useStyles = makeStyles({
  subTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
})

const PasswordReset = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const filterStyles = filterStylesComponents()
  const history = useHistory()

  const [error, setError] = useState('')

  const [showPassword, setShowPassword] = useState({
    new: false,
    old: false,
    confirmation: false,
  })

  const handleShowPassword = name => {
    setShowPassword({ ...showPassword, [name]: !showPassword[name] })
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    if (values?.confirmation != values?.new_password) {
      return setError('As senhas não coincidem')
    }

    try {
      const resp = await dispatch(resetPassword(values))

      if (resp) {
        history.goBack()
      }
    } catch (e) {
      //
    }
  }

  return (
    <BaseCreatePage
      page="Usuário"
      path="Resetar Senha"
      pageLink="/"
      hiddenReturn
      goBack
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box className={classes.subTitle}>
            Utilize os campos abaixo para resetar a senha
          </Box>
        </Grid>

        <Grid item xs={12}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4} md={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      label="Senha Antiga"
                      name="old_password"
                      type={showPassword?.old ? 'text' : 'password'}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title={
                                !showPassword?.old
                                  ? 'Revelar senha'
                                  : 'Esconder Senha'
                              }
                              aria-label="password"
                            >
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => handleShowPassword('old')}
                              >
                                {showPassword?.old ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      label="Senha nova"
                      name="new_password"
                      type={showPassword?.new ? 'text' : 'password'}
                      helperText={error}
                      error={error}
                      onChange={() => setError('')}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title={
                                !showPassword?.new
                                  ? 'Revelar senha'
                                  : 'Esconder Senha'
                              }
                              aria-label="password"
                            >
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => handleShowPassword('new')}
                              >
                                {showPassword?.new ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      label="Confirmar senha"
                      name="confirmation"
                      type={showPassword?.confirmation ? 'text' : 'password'}
                      helperText={error}
                      error={error}
                      onChange={() => setError('')}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title={
                                !showPassword?.confirmation
                                  ? 'Revelar senha'
                                  : 'Esconder Senha'
                              }
                              aria-label="password"
                            >
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() =>
                                  handleShowPassword('confirmation')
                                }
                              >
                                {showPassword?.confirmation ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Grid
                      container
                      justifyContent="flex-end"
                      alignItems="flex-end"
                    >
                      <Button className={filterStyles.btnSalvar} type="submit">
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}

export default PasswordReset
